module.exports = __webpack_public_path__ + "img/dropdown-icon.c351ce95.svg";